import { Component, ChangeDetectionStrategy, Injector, Input } from '@angular/core';

import { CommonBaseComponent } from '../base_component/base.component';
import { CommonAppDataService } from '../app_data/app_data.service';

const FIRST_DOT_REGEX = /^[^.]*\./;

@Component({
	selector: 'common-app-name-component',
	templateUrl: './common-app-name.component.pug',
	styleUrls: ['./common-app-name.component.sass'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'class': 'app_name',
	},
})

export class CommonAppNameComponent extends CommonBaseComponent {
	@Input() logoImageUrl: string;

	firstPart: string = '';
	lastPart: string = '';
	appName: string = '';

	commonAppDataService = this.injector.get(CommonAppDataService);

	constructor(
		protected injector: Injector,
	) {
		super(injector);
		const appData = this.commonAppDataService.getData();
		this.appName = appData.appName;

		if (FIRST_DOT_REGEX.exec(appData.appName)) {
			this.firstPart = FIRST_DOT_REGEX.exec(appData.appName)[0];
			this.lastPart = appData.appName.split(FIRST_DOT_REGEX)[1];
		} else {
			this.firstPart = appData.appName;
		}
	}
}
